export default [
  {
    path: '/',
    component: () => import('~/common/layouts/Auth.vue'),
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('~/authentication/pages/Login.vue'),
      },
      {
        path: 'register/:uuid',
        name: 'register',
        component: () => import('~/authentication/pages/Register.vue'),
        props(route) {
          let props = { ...route.params };
          return props;
        },
      },
      {
        path: 'forgotten-password',
        name: 'forgotten-password',
        component: () => import('~/authentication/pages/ForgottenPassword.vue'),
      },
      {
        path: 'reset-password',
        redirect: '/login',
      },
      {
        path: 'reset-password/:token',
        name: 'reset-password',
        component: () => import('~/authentication/pages/ResetPassword.vue'),
        props(route) {
          let props = { ...route.params };
          return props;
        },
      },
    ],
  },
];
